import { render, staticRenderFns } from "./colorAnalysis.vue?vue&type=template&id=a2f6e0c4&scoped=true&"
import script from "./colorAnalysis.vue?vue&type=script&lang=js&"
export * from "./colorAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./colorAnalysis.vue?vue&type=style&index=0&id=a2f6e0c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f6e0c4",
  null
  
)

export default component.exports